import * as i0 from '@angular/core';
import { Injectable, Inject } from '@angular/core';
import { WINDOW } from '@upr-web-primer/window';
import { get } from 'lodash-es';
import { fromEvent, BehaviorSubject } from 'rxjs';
import { throttleTime, map } from 'rxjs/operators';

class NavigationService {
    constructor(zone, window) {
        this.zone = zone;
        this.window = window;
        this.toggle = false;
        this.subtoggle = false;
        this.searchBarToggle = false;
        this.subNavItem = -1;
        this.guestCtaOpen = false;
        this.zone.runOutsideAngular(() => {
            this.stickyNavOpen$ = fromEvent(this.window, 'scroll').pipe(throttleTime(50, undefined, {
                leading: true,
                trailing: true
            }), map(event => {
                const top = get(event, 'target.scrollingElement.scrollTop') ||
                    get(this.window, 'document.documentElement.scrollTop', 0);
                return top >= 450;
            }));
        });
        this.guestCta$ = new BehaviorSubject(this.guestCtaOpen);
        this.isMobileNavOpen$ = new BehaviorSubject(this.toggle);
        this.isMobileSubnavOpen$ = new BehaviorSubject(this.subtoggle);
        this.currentSubNavItem$ = new BehaviorSubject(this.subNavItem);
        this.searchBarOpen$ = new BehaviorSubject(this.searchBarToggle);
    }
    toggleMobileNav() {
        this.toggle = !this.toggle;
        this.isMobileNavOpen$.next(this.toggle);
    }
    deactivateMobileNav() {
        this.toggle = false;
        this.isMobileNavOpen$.next(this.toggle);
    }
    toggleMobileSubNav() {
        this.subtoggle = !this.subtoggle;
        this.isMobileSubnavOpen$.next(this.subtoggle);
    }
    deactivateMobileSubNav() {
        this.subtoggle = false;
        this.isMobileSubnavOpen$.next(false);
    }
    toggleSearchBar() {
        this.searchBarToggle = !this.searchBarToggle;
        this.searchBarOpen$.next(this.searchBarToggle);
    }
    deactivateSearchBar() {
        this.searchBarToggle = false;
        this.searchBarOpen$.next(this.searchBarToggle);
    }
    toggleGuestCTA(state) {
        this.guestCtaOpen = state;
        this.guestCta$.next(this.guestCtaOpen);
    }
    deactivateGuestCTA() {
        this.guestCtaOpen = false;
        this.guestCta$.next(this.guestCtaOpen);
    }
}
NavigationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NavigationService, deps: [{ token: i0.NgZone }, { token: WINDOW }], target: i0.ɵɵFactoryTarget.Injectable });
NavigationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NavigationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NavigationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i0.NgZone }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }]; } });

export { NavigationService };
